import classNames from 'classnames'

const MonthButton = ({
  selected,
  title,
  subtitle,
  onClick,
}) => {
  return (
    <div onClick={onClick} className={classNames('move-month-button px-2 py-5 gap-1 rounded-2xl', { [`move-month-button--selected`]: selected })}>
      <span className="label-medium leading-none text-primary text-md font-semibold">{title}</span>
      <span className="body-mini leading-none text-primary text-xs font-medium">{subtitle}</span>
    </div>
  )
}

export default MonthButton
